const Notification = () => ({
  width: 0,

  height: 0,

  skew: 60,

  border: 1.5 / 2,

  get initialized() {
    return this.width !== 0 && this.height !== 0;
  },

  get viewbox() {
    return `0 0 ${this.width} ${this.height}`;
  },

  get polygon() {
    const points = [
      [this.skew + this.border, this.border],
      [this.width - this.border, this.border],
      [this.width - this.skew - this.border, this.height - this.border],
      [this.border, this.height - this.border]
    ];
    return points.map((p) => p.join(' ')).join(', ');
  },

  onResize() {
    this.width = this.$root.offsetWidth;
    this.height = this.$root.offsetHeight;
  }
});

export default Notification;
